export const SET_TOKEN_VALIDATION_STATE = 'SET_TOKEN_VALIDATION_STATE';
export const FILL_AUTH_SERVICE_POINT_DATA = 'FILL_AUTH_SERVICE_POINT_DATA';
export const TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
export const SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
export const SET_AFTER_AUTHORIZATION_URL = 'SET_AFTER_AUTHORIZATION_URL';
export const SET_FORM_TYPE = 'SET_FORM_TYPE';
export const SET_FORM_PARAMS = 'SET_FORM_PARAMS';
export const SET_QR_CODE = 'SET_QR_CODE';
export const SET_LOGIN_TOKEN = 'SET_LOGIN_TOKEN';
export const SET_OTP_STAMP = 'SET_OTP_STAMP';
export const SET_BLOCK_TIME = 'SET_BLOCK_TIME';


// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/mutations-types.js